module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC6SURBVHgB7dPBDYIwFAbgv00P6skRYAMYgUlkA13BDXQDncQRZAMYgZMa0vTZnrwI5JVye1/SpM3fNH9eUkAIIYTgUYjwbNu9+dijI6r9E5lfnVZ0sxtzLfO8BxO7RCig3/bht8WfuHFbU3GLaDBpP4GRAkGhX/YE7pvgIlVP5kodsHoJULYsT1OiW5YnKOFI3ScvzOUpSmAwFxCakbRxO5+vXaIs894NpnKE82/01IVzzPcUQgghYnwBzUw9GfB9PAIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/dot.png
// module id = f6T9
// module chunks = 1